import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { ThumbsUpReaction } from '@mentimeter/ragnar-visuals';
import { ICON_SIZE } from './constants';

export const QfaUpvotes = ({
  numberOfUpvotes,
}: {
  numberOfUpvotes: number;
}) => {
  return (
    <Box mt="space8" flexDirection="row" alignItems="center">
      <ThumbsUpReaction size={ICON_SIZE} color="text" />
      <Text
        data-testid="qfa-upvotes"
        fontSize="175"
        color="text"
        lineHeight="none"
        ml="space2"
      >
        {numberOfUpvotes}
      </Text>
    </Box>
  );
};
